function customizedThemeInit(){

    document.documentElement.style.setProperty('--afterOnOff', "none")

    // customized-theme.css hides every .flickity-page-dots (visibility:hidden) so the dots
    // do not flash before Flickity has laid them out. Reveal them once the page has loaded,
    // but skip the PDP main gallery: pdp-custom.css deliberately keeps those hidden until
    // product-template.liquid adds .show-dots to .product__main-photos after 6s, and an
    // inline style here would override that rule.
    var pageDots = document.querySelectorAll(".flickity-page-dots")
    Array.prototype.forEach.call(pageDots, function (dots) {
      if (dots.closest && dots.closest(".product__main-photos")) { return }
      dots.style.visibility = 'visible'
    })

}

if (document.readyState === 'complete') {
    customizedThemeInit();
} else {
    window.addEventListener('load', customizedThemeInit);
}
